<template>
    <div id="app" class="gocc">
        <router-view/>
        <response-bar
            v-if="response.has"
            class="gocc__page__response"
            :settings="{
                status: response.type,
                message: response.message
            }"
            :message="response.message"
        />
    </div>
</template>

<script>
import { watch } from '@vue/composition-api';

// store
import { mapState, useActions } from '@/hooks/use-store';

export default {
    components: {
        ResponseBar: () => import( /* webpackChunkName: 'ResponseBar' */ '@/components/bundles/bars/response/ResponseBar' )
    },
    setup ( _, { root }) {
        // obtenção da resposta
        const response = mapState({ module: 'storePayload', key: 'response' });

        // reset do payload aquando a mudança
        // de rota.
        const { actions } = useActions();

        watch( () => root.$route,
            () => {
                actions( 'resetState' );
            });

        return { response };
    }
};
</script>

<style lang="scss">
    @import '@/styles/global.scss';
</style>